<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="220px">
      <!-- 上传 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.identificationImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.identificationImg"
              @handleImgSuccess="ficationImgSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.identificationBackImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.identificationBackImg"
              @handleImgSuccess="ficationImgBackSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.driverImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 必填 -->
      <el-row>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.name"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('name')"
          />
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入姓名"
              clearable
              @change="
                value => {
                  form.name = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.sex"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('sex')"
          />
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别">
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              autocomplete="off"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.password"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('password')"
          />
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
              clearable
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.workCompany"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('workCompany')"
          />
          <el-form-item label="工作单位" prop="workCompany">
            <el-input
              v-model="form.workCompany"
              placeholder="请输入工作单位"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.identificationNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('identificationNumber')"
          />
          <el-form-item label="公民身份证号码" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入公民身份证号码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="checkQuire ? 12 : 9">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.idCardDueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('idCardDueDate')"
          />
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="!checkQuire" :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.areaList"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('areaList')"
          />
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              clearable
              placeholder="请选择通信地址"
              @change="changeAreaList"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.homeAddress"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('homeAddress')"
          />
          <el-form-item label="住址" prop="homeAddress">
            <el-input
              v-model="form.homeAddress"
              placeholder="请输入住址"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.driverLicenseImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '机动车驾驶证照片',
                  prefix: 'driverLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.driverLicenseImg"
                @handleImgSuccess="driverLicenseSuccess"
              />
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.driverLicenseImgBack"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '机动车驾驶证副页照片',
                  prefix: 'driverLicenseBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.driverLicenseBackImg"
                @handleImgSuccess="driverLicenseBackSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.driverLicense"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('driverLicense')"
          />
          <el-form-item label="机动车驾驶证号" prop="driverLicense">
            <el-input
              v-model="form.driverLicense"
              placeholder="请输入机动车驾驶证号"
              clearable
              @change="
                value => {
                  form.driverLicense = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.fileNo"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('fileNo')"
          />
          <el-form-item label="档案编号" prop="fileNo">
            <el-input
              v-model="form.fileNo"
              placeholder="请输入档案编号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.driverIssuingOrganizations"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('driverIssuingOrganizations')"
          />
          <el-form-item
            label="机动车驾驶证发证机关"
            prop="driverIssuingOrganizations"
          >
            <el-input
              v-model="form.driverIssuingOrganizations"
              placeholder="请输入机动车驾驶证发证机关"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vehicleClass"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vehicleClass')"
          />
          <el-form-item label="准驾类型" prop="vehicleClass">
            <el-select
              v-model="form.vehicleClass"
              placeholder="请选择准驾类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleTypeAllowList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.firstIssueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('firstIssueDate')"
          />
          <el-form-item label="机动车驾驶证初次领证日期" prop="firstIssueDate">
            <el-date-picker
              v-model="form.firstIssueDate"
              type="date"
              placeholder="请选择机动车驾驶证初次领证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.driverLicenseFromDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('driverLicenseFromDate')"
          />
          <el-form-item
            label="机动车驾驶证有效期自"
            prop="driverLicenseFromDate"
          >
            <el-date-picker
              v-model="form.driverLicenseFromDate"
              type="date"
              placeholder="请选择机动车驾驶证有效期开始日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="checkQuire ? 12 : 9">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.driverLicenseDueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('driverLicenseDueDate')"
          />
          <el-form-item
            label="机动车驾驶证有效期至"
            prop="driverLicenseDueDate"
          >
            <el-date-picker
              v-model="form.driverLicenseDueDate"
              :class="form.hasDriverDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择机动车驾驶证有效期结束日期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDriverDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="!checkQuire" :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDriverDueDate"
              @change="
                value => {
                  this.$set(
                    form,
                    'driverLicenseDueDate',
                    value ? '9999-12-31' : ''
                  );
                }
              "
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.workLicenseImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                v-if="ctmsShow"
                :upload-config="{
                  lebal: '道路运输从业资格证照片',
                  prefix: 'workLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.workLicenseImg"
                @handleImgSuccess="workLicenseSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.workLicense"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('workLicense')"
          />
          <el-form-item label="道路运输从业资格证号" prop="workLicense">
            <el-input
              v-model="form.workLicense"
              placeholder="请输入道路运输从业资格证号"
              clearable
              @change="
                value => {
                  form.workLicense = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.approvedDriving"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('approvedDriving')"
          />
          <el-form-item
            label="道路运输从业资格证准驾车型"
            prop="approvedDriving"
          >
            <el-input
              v-model="form.approvedDriving"
              placeholder="请输入道路运输从业资格证准驾车型"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.qualificationCategory"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('qualificationCategory')"
          />
          <el-form-item
            label="道路运输从业资格证从业资格类别"
            prop="qualificationCategory"
          >
            <el-input
              v-model="form.qualificationCategory"
              placeholder="请输入道路运输从业资格证从业资格类别"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.initialCertificationDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('initialCertificationDate')"
          />
          <el-form-item
            label="道路运输从业资格证初次领证日期"
            prop="initialCertificationDate"
          >
            <el-date-picker
              v-model="form.initialCertificationDate"
              type="date"
              placeholder="请选择道路运输从业资格证初次领证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.workLicenseDueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('workLicenseDueDate')"
          />
          <el-form-item
            label="道路运输从业资格证到期日期"
            prop="workLicenseDueDate"
          >
            <el-date-picker
              v-model="form.workLicenseDueDate"
              type="date"
              placeholder="请选择道路运输从业资格证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'liaoning'" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.businessUniformSocialCreditCode"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('businessUniformSocialCreditCode')"
          />
          <el-form-item
            label="道路经营业户社会信用代码"
            prop="businessUniformSocialCreditCode"
          >
            <el-input
              v-model="form.businessUniformSocialCreditCode"
              placeholder="道路经营业户社会信用代码"
              clearable
              @change="
                value => {
                  form.businessUniformSocialCreditCode = value.replace(
                    /\W/g,
                    ''
                  );
                }
              "
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.roadPermitNumberImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                v-if="ctmsShow"
                :upload-config="{
                  lebal: '道路运输经营许可证照片',
                  prefix: 'roadPermitNumber',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.roadPermitNumberImg"
                @handleImgSuccess="roadPermitNumberSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadPermitName"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadPermitName')"
          />
          <el-form-item label="道路经营许可证业户名称" prop="roadPermitName">
            <el-input
              v-model="form.roadPermitName"
              placeholder="请输入道路经营许可证业户名称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadPermitNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadPermitNumber')"
          />
          <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路运输经营许可证号"
              clearable
              @change="
                value => {
                  form.roadPermitNumber = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆的可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.businessScope"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('businessScope')"
          />
          <el-form-item label="道路运输经营许可证经营范围" prop="businessScope">
            <el-input
              v-model="form.businessScope"
              placeholder="请输入道路运输经营许可证经营范围"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.periodValidity"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('periodValidity')"
          />
          <el-form-item
            label="道路运输经营许可证证件有效期"
            prop="periodValidity"
          >
            <el-input
              v-model="form.periodValidity"
              placeholder="请输入道路运输经营许可证证件有效期"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 车辆证件 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.vehicleLicenseImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证正页照片',
                  prefix: 'vehicleLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.vehicleLicenseImg"
                @handleImgSuccess="vehicleLicenseSuccess"
              />
            </div>
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.vehicleLicenseDeputyPageImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证副页照片',
                  prefix: 'vehicleLicenseDeputyPage',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.vehicleLicenseDeputyPageImg"
                @handleImgSuccess="vehicleLicenseBackSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="号牌号码" prop="licenseNumber">
            <el-input
              v-model="form.licenseNumber"
              placeholder="请输入号牌号码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vehicleLicenseColor"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vehicleLicenseColor')"
          />
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.classificationCode"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('classificationCode')"
          />
          <el-form-item label="车辆类型" prop="classificationCode">
            <el-select
              v-model="form.classificationCode"
              placeholder="请选择车辆类型"
              clearable
              filterable
              @change="isVehicleType"
            >
              <el-option
                v-for="item in parentData.vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.totalWeight"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('totalWeight')"
          />
          <el-form-item
            :label="
              form.isHasTrailer == 1 ? '车头整备质量(kg)' : '车辆总质量(kg)'
            "
            prop="totalWeight"
          >
            <el-input
              v-model="form.totalWeight"
              type="number"
              :placeholder="
                form.isHasTrailer == 1
                  ? '请输入车头整备质量'
                  : '请输入车辆总质量'
              "
              clearable
              @mousewheel.native.prevent
              @DOMMouseScroll.native.prevent
              @change="value => setkey(value, 'totalWeight')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.loadWeight"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('loadWeight')"
          />
          <el-form-item
            :label="
              form.isHasTrailer == 1 ? '准牵引总质量(kg)' : '核定载质量(kg)'
            "
            prop="loadWeight"
          >
            <el-input
              v-model="form.loadWeight"
              type="number"
              :placeholder="
                form.isHasTrailer == 1
                  ? '请输入准牵引总质量'
                  : '请输入核定载质量'
              "
              clearable
              @mousewheel.native.prevent
              @DOMMouseScroll.native.prevent
              @change="value => setkey(value, 'loadWeight')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.dimension"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('dimension')"
          />
          <el-col :span="12">
            <el-form-item class="dif" prop="length" label="外廓尺寸mm">
              <el-input
                v-model="form.length"
                placeholder="请输入车辆长度"
                clearable
                @change="value => setkey(value, 'length')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="dif" prop="width" label-width="10px">
              *
              <el-input
                v-model="form.width"
                style="padding-left: 6px"
                placeholder="请输入车辆宽度"
                clearable
                @change="value => setkey(value, 'width')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="dif" prop="height" label-width="10px">
              *
              <el-input
                v-model="form.height"
                style="padding-left: 6px"
                placeholder="请输入车辆高度"
                clearable
                @change="value => setkey(value, 'height')"
              />mm
            </el-form-item>
          </el-col>
        </el-col>
        <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <!-- * -->
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.axlenum"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('axlenum')"
          />
          <el-form-item label="车轴数" prop="axlenum">
            <el-input
              v-model="form.axlenum"
              placeholder="请输入车轴数"
              clearable
              maxlength="2"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.owner"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('owner')"
          />
          <el-form-item label="车辆所有人" prop="owner">
            <el-input
              v-model="form.owner"
              placeholder="请输入车辆所有人"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vehicleLicense"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vehicleLicense')"
          />
          <el-form-item label="车辆行驶证档案编号" prop="vehicleLicense">
            <el-input
              v-model="form.vehicleLicense"
              placeholder="请输入车辆行驶证档案编号"
              clearable
              @change="
                value => {
                  form.vehicleLicense = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:行驶证若不存在档案编号可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vehicleLicenseDueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vehicleLicenseDueDate')"
          />
          <el-form-item label="车辆行驶证到期日期" prop="vehicleLicenseDueDate">
            <el-date-picker
              v-model="form.vehicleLicenseDueDate"
              type="date"
              placeholder="请选择车辆行驶证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.brandModel"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('brandModel')"
          />
          <el-form-item label="品牌型号" prop="brandModel">
            <el-input
              v-model="form.brandModel"
              placeholder="请输入品牌型号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.engineNo"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('engineNo')"
          />
          <el-form-item label="发动机号码" prop="engineNo">
            <el-input
              v-model="form.engineNo"
              placeholder="请输入发动机号码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.useCharacter"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('useCharacter')"
          />
          <el-form-item label="车辆使用性质" prop="useCharacter">
            <el-input
              v-model="form.useCharacter"
              placeholder="请输入车辆使用性质"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.approvedPassengers"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('approvedPassengers')"
          />
          <el-form-item label="核定载人数" prop="approvedPassengers">
            <el-input
              v-model="form.approvedPassengers"
              placeholder="请输入核定载人数"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.unladenMass"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('unladenMass')"
          />
          <el-form-item label="整备质量" prop="unladenMass">
            <el-input
              v-model="form.unladenMass"
              placeholder="请输入整备质量"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vin"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vin')"
          />
          <el-form-item label="车辆识别代号" prop="vin">
            <el-input
              v-model="form.vin"
              placeholder="请输入车辆识别代号"
              clearable
              @change="
                value => {
                  form.vin = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vehicleIssuingOrganizations"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vehicleIssuingOrganizations')"
          />
          <el-form-item
            label="车辆行驶证发证机关"
            prop="vehicleIssuingOrganizations"
          >
            <el-input
              v-model="form.vehicleIssuingOrganizations"
              placeholder="请输入车辆行驶证发证机关"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.registerDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('registerDate')"
          />
          <el-form-item label="车辆行驶证注册日期" prop="registerDate">
            <el-date-picker
              v-model="form.registerDate"
              type="date"
              placeholder="请选择车辆行驶证注册日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.issueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('issueDate')"
          />
          <el-form-item label="车辆行驶证发证日期" prop="issueDate">
            <el-date-picker
              v-model="form.issueDate"
              type="date"
              placeholder="请选择车辆行驶证发证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="compTrailer">
        <el-col :span="24">
          <el-form-item label="挂车证件">
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.trailerVehicleLicenseImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车行驶证正页照片',
                prefix: 'trailerVehicleLicense',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerVehicleLicenseImg"
              @handleImgSuccess="trailerVehicleLicenseImgSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.trailerVehicleLicenseDeputyPageImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车行驶证副页照片',
                prefix: 'trailerVehicleLicenseDeputyPage',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerVehicleLicenseDeputyPageImg"
              @handleImgSuccess="trailerVehicleLicenseDeputyPageImgSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.trailerVehicleImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车照片',
                prefix: 'trailerVehicle',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerVehicleImg"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.trailerRoadTransportCertificateImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车道路运输证照片',
                prefix: 'trailerRoadTransportCertificate',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerRoadTransportCertificateImg"
              @handleImgSuccess="trailerTransportCertificateImgSuccess"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.trailerNum"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('trailerNum')"
          />
          <el-form-item label="挂车车牌号" prop="trailerNum">
            <el-input
              v-model="form.trailerNum"
              placeholder="请输入挂车车牌号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.trailerLicenseColor"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('trailerLicenseColor')"
          />
          <el-form-item label="挂车车牌颜色" prop="trailerLicenseColor">
            <el-select
              v-model="form.trailerLicenseColor"
              placeholder="请选择挂车车牌颜色"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleLicenseColorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.trailerClassificationCode"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('trailerClassificationCode')"
          />
          <el-form-item label="挂车车辆类型" prop="trailerClassificationCode">
            <el-select
              v-model="form.trailerClassificationCode"
              placeholder="请选择挂车车辆类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in parentData.vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.trailerTotalWeight"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('trailerTotalWeight')"
          />
          <el-form-item label="挂车总质量(kg)" prop="trailerTotalWeight">
            <el-input
              v-model="form.trailerTotalWeight"
              placeholder="请输入挂车总质量"
              @change="value => setkey(value, 'trailerTotalWeight')"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.trailerLoadWeight"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('trailerLoadWeight')"
          />
          <el-form-item label="挂车核定载质量(kg)" prop="trailerLoadWeight">
            <el-input
              v-model="form.trailerLoadWeight"
              placeholder="请输入挂车核定载质量"
              @change="value => setkey(value, 'trailerLoadWeight')"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.trailerRoadTransport"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('trailerRoadTransport')"
          />
          <el-form-item label="挂车道路运输证号" prop="trailerRoadTransport">
            <el-input
              v-model="form.trailerRoadTransport"
              placeholder="请输入挂车道路运输证号"
              @change="
                value => {
                  form.trailerRoadTransport = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.roadTransportCertificateImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                v-if="ctmsShow"
                :upload-config="{
                  lebal: '道路运输证照片',
                  prefix: 'roadTransportCertificate',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.roadTransportCertificateImg"
                @handleImgSuccess="roadTransportCertificateSuccess"
              />
            </div>
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire && hasTaxOpen"
                v-model="requireData.stateImg"
                style="margin-righgt: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                v-if="hasTaxOpen"
                :upload-config="{
                  lebal: '车主声明',
                  prefix: 'state',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.stateImg || form.isLinked"
              />
            </div>
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire && hasTaxOpen"
                v-model="requireData.depenDealImg"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                v-if="form.isLinked"
                :upload-config="{
                  lebal: '挂靠协议照片',
                  prefix: 'depenDeal',
                  form: form,
                  suffix: 'Img'
                }"
                :required="true"
                :parent-data="parentData"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadTransportCertificateNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadTransportCertificateNumber')"
          />
          <el-form-item
            label="车辆道路运输证号"
            prop="roadTransportCertificateNumber"
          >
            <el-input
              v-model="form.roadTransportCertificateNumber"
              placeholder="请输入车辆道路运输证号"
              clearable
              @change="
                value => {
                  form.roadTransportCertificateNumber = value.replace(
                    /\W/g,
                    ''
                  );
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadTransportPermitNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadTransportPermitNumber')"
          />
          <el-form-item
            label="经营许可证号(道路运输证)"
            prop="roadTransportPermitNumber"
          >
            <el-input
              v-model="form.roadTransportPermitNumber"
              placeholder="请输入经营许可证号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.economicType"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('economicType')"
          />
          <el-form-item label="道路运输证经济类型" prop="economicType">
            <el-input
              v-model="form.economicType"
              placeholder="请输入道路运输证经济类型"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.typeRoadTransportVehicle"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('typeRoadTransportVehicle')"
          />
          <el-form-item
            label="道路运输证车辆类型"
            prop="typeRoadTransportVehicle"
          >
            <el-input
              v-model="form.typeRoadTransportVehicle"
              placeholder="请输入道路运输证车辆类型"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.shippingTon"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('shippingTon')"
          />
          <el-form-item label="道路运输证车辆吨位(吨)" prop="shippingTon">
            <el-input
              v-model="form.shippingTon"
              placeholder="请输入道路运输证车辆吨位"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.businessScopeTransportation"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('businessScopeTransportation')"
          />
          <el-form-item
            label="道路运输证经营范围"
            prop="businessScopeTransportation"
          >
            <el-input
              v-model="form.businessScopeTransportation"
              placeholder="请输入道路运输证经营范围"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadTransportCertificateDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadTransportCertificateDate')"
          />
          <el-form-item
            label="道路运输证到期日期"
            prop="roadTransportCertificateDate"
          >
            <el-date-picker
              v-model="form.roadTransportCertificateDate"
              type="date"
              placeholder="请选择道路运输证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'liaoning'" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadTransportCertificateWord"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadTransportCertificateWord')"
          />
          <el-form-item
            label="车辆道路运输证字"
            prop="roadTransportCertificateWord"
          >
            <el-input
              v-model="form.roadTransportCertificateWord"
              placeholder="请输入车辆道路运输证字"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.isLinked"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('isLinked')"
          />
          <el-form-item label="是否挂靠车辆" prop="isLinked">
            <el-select v-model="form.isLinked" placeholder="请选择">
              <el-option
                v-for="item in isLinkedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col v-if="hasTaxOpen" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.realOwner"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('realOwner')"
          />
          <el-form-item label="车辆实际所有人" prop="realOwner">
            <el-input
              v-model="form.realOwner"
              placeholder="请输入车辆实际所有人"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="hasTaxOpen" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.brand"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('brand')"
          />
          <el-form-item label="车辆品牌" prop="brand">
            <el-input
              v-model="form.brand"
              placeholder="请输入车辆品牌"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- <el-checkbox
            v-if="checkQuire"
            v-model="requireData.isHasTrailer"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('isHasTrailer')"
          />
          <el-form-item label="是否挂车" prop="isHasTrailer">
            <el-select v-model="form.isHasTrailer" placeholder="请选择">
              <el-option
                v-for="item in isHasTrailerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        </el-col></el-row
      >

      <!-- 总重量<=4.5吨(必填) -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="车辆总质量<=4.5吨必填项">
            <el-switch v-model="showExtra" :disabled="disabled" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :hidden="!showExtra">

      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="其他上传">
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.driverImg"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '实际承运人半身照',
                  prefix: 'driver',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.driverImg"
              />
            </div>
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.safeDutyInsureImg"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '安全责任险照片',
                  prefix: 'safeDutyInsure',
                  form: form,
                  suffix: 'Img',
                  isRequired: false
                }"
                :required="!!requireData.safeDutyInsureImg"
                :parent-data="parentData"
              />
            </div>
            <div style="display: inline-block">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.vehicleImg"
                style="margin-right: 10px"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '车辆照片',
                  prefix: 'vehicle',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.vehicleImg"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 选填 -->
      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="其他">
            <el-switch v-model="otherItems" disabled />
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row v-if="otherItems">
        <el-col :span="12">
          <el-form-item label="车牌颜色" prop="vehicleLicenseColor">
            <el-select
              v-model="form.vehicleLicenseColor"
              placeholder="请选择车牌颜色"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleLicenseColorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.vehicleEnergyType"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('vehicleEnergyType')"
          />
          <el-form-item label="车辆能源类型" prop="vehicleEnergyType">
            <el-select
              v-model="form.vehicleEnergyType"
              placeholder="请选择车辆能源类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleEnergyTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.selfRespect"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('selfRespect')"
          />
          <el-form-item label="车身自重(kg)" prop="selfRespect">
            <el-input
              v-model="form.selfRespect"
              placeholder="请输入车身自重"
              clearable
              @change="value => setkey(value, 'selfRespect')"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="hasTaxOpen" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.realOwnerPhone"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('realOwnerPhone')"
          />
          <el-form-item label="车辆实际所有人联系电话" prop="realOwnerPhone">
            <el-input
              v-model="form.realOwnerPhone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </el-col> -->

        <!-- <el-col :span="12"> -->
        <!-- <el-checkbox v-if="checkQuire" :true-label="1" :false-label="0" class="bigCheckBox" @change="setQuired('locationSource')" v-model="requireData.locationSource"></el-checkbox> -->
        <!-- <el-form-item label="定位来源" prop="locationSource">
            <el-select
              v-model="form.locationSource"
              placeholder="请选择定位来源"
            >
              <el-option
                v-for="item in parentData.locationSourceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item>
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.safeDutyInsureImg"
              :true-label="1"
              :false-label="0"
              @change="setQuired('safeDutyInsureImg')"
            />
            <ImgUpload
              :upload-config="{ lebal: '安全责任险照片', prefix: 'safeDutyInsure', form: form, suffix: 'Img', isRequired: false }"
              :required="!!requireData.safeDutyInsureImg"
              :parent-data="parentData"
            />

          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <el-button v-if="!checkQuire" type="primary" plain @click="funcSubmit()">
      提交
    </el-button>
    <el-button v-if="checkQuire" type="primary" plain @click="funcSaveSet()">
      保存必填设置
    </el-button>
  </div>
</template>
<script>
import { addDriverTeam, isTaxOpen } from "@/api/driver.js";
import ImgUpload from "@/components/ImgUpload";
import { findByFieldFrom, updateFieldRequired } from "@/api/required";
import { getOcr } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
import { realDay } from "@/utils/validate";
import { maxNumber, checkPassword } from "@/utils/validate4Form.js";
import {
  validatePhone,
  validateIDNumber,
  validateCarNum
} from "@/utils/validate.js";
export default {
  name: "DriverAdd",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          vehicleEnergyTypeList: []
        };
      }
    }
  },
  data() {
    return {
      showExtra: true,
      otherItems: true,
      ctmsShow: true,
      hasDueDate: false,
      hasTaxOpen: "",
      form: {
        driverType: 0,
        workLicenseImg: "",
        driverImg: "",
        driverLicenseImg: "",
        driverLicenseBackImg: "",
        identificationBackImg: "",
        identificationImg: "",
        trailerVehicleLicenseImg: "",
        trailerRoadTransportCertificateImg: "",
        trailerVehicleImg: "",
        roadTransportCertificateImg: "",
        vehicleImg: "",
        vehicleLicenseImg: "",
        vehicleLicenseDeputyPageImg: "",
        trailerVehicleLicenseDeputyPageImg: "",
        roadPermitNumberImg: "",
        workLicenseDueDate: "",
        locationSource: "0",
        isLinked: 0,
        isHasTrailer: 0,
        vehicleDTO: {},
        vehicleVO: {},
        sex: 1
      },
      ficationImgRes: {},
      driverLicenseRes: {},
      ocrDrivingLicenseFY: {},
      // 必填功能
      checkQuire: false,
      isAdmin: false,
      reportProvinceName: "",
      requireData: {},
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 校验
      rules: {
        roadPermitNumber: [
          {
            required: false,
            message: "请输入道路经营许可证号",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        vehicleLicenseColor: [
          { required: false, message: "请选择车牌颜色", trigger: "change" }
        ],
        vehicleEnergyType: [
          { required: false, message: "请选择车辆能源类型", trigger: "change" }
        ],
        name: [
          { required: false, message: "请输入姓名", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" }
        ],
        driverIssuingOrganizations: [
          {
            required: false,
            message: "请输入机动车驾驶证发证机关",
            trigger: "blur"
          }
        ],
        vehicleIssuingOrganizations: [
          {
            required: false,
            message: "请输入车辆行驶证发证机关",
            trigger: "blur"
          }
        ],
        driverLicenseFromDate: [
          {
            required: false,
            message: "请选择机动车驾驶证有效期开始日期",
            trigger: "change"
          }
        ],
        roadTransportCertificateWord: [
          {
            required: false,
            message: "请输入车辆道路运输证字",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        issueDate: [
          {
            required: false,
            message: "请选择车辆行驶证发证日期",
            trigger: "change"
          }
        ],
        useCharacter: [
          { required: false, message: "请输入车辆使用性质", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        identificationNumber: [
          {
            required: false,
            message: "请输入公民身份证号码",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              validateIDNumber(value)
                ? callback()
                : callback(new Error("请输入正确的公民身份证号码"));
            }
          }
        ],
        idCardDueDate: [
          {
            required: false,
            message: "请选择身份证有效日期",
            trigger: "change"
          }
        ],
        homeAddress: [
          { required: false, message: "请输入住址", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        annualReviewTime: [
          { required: false, message: "请选择年审时间", trigger: "change" }
        ],
        axlenum: [
          { required: false, message: "请输入车轴数", trigger: "blur" }
        ],
        vehicleClass: [
          { required: false, message: "请选择准驾类型", trigger: "change" }
        ],
        workLicense: [
          {
            required: false,
            message: "请输入道路运输从业资格证号",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        // workCompany: [
        //   { required: false, message: "请输入工作单位", trigger: "blur" },
        //   { max: 255, message: "最大长度为255个字符" }
        // ],
        workLicenseDueDate: [
          {
            required: false,
            message: "请选择道路运输从业资格证到期日期",
            trigger: "change"
          }
        ],
        vehicleLicenseDueDate: [
          {
            required: false,
            message: "请选择车辆行驶证到期日期",
            trigger: "change"
          }
        ],
        registerDate: [
          {
            required: false,
            message: "请选择车辆行驶证注册日期",
            trigger: "change"
          }
        ],
        roadTransportCertificateDate: [
          {
            required: false,
            message: "请选择道路运输证到期日期",
            trigger: "change"
          }
        ],
        selfRespect: [
          { required: false, message: "请输入车身自重", trigger: "change" },
          { validator: maxNumber }
        ],
        totalWeight: [
          { required: false, message: "请选择车辆总质量", trigger: "change" },
          { validator: maxNumber }
        ],
        height: [
          { required: false, message: "请输入车辆高度", trigger: "blur" },
          { validator: maxNumber }
        ],
        width: [
          { required: false, message: "请输入车辆宽度", trigger: "blur" },
          { validator: maxNumber }
        ],
        length: [
          { required: false, message: "请输入车辆长度", trigger: "blur" },
          { validator: maxNumber }
        ],
        trailerNum: [
          {
            required: false,
            message: "请输入挂车车牌号",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback();
              }
              validateCarNum(value)
                ? callback()
                : callback(new Error("请输入正确的挂车车牌号"));
            }
          }
        ],
        trailerLicenseColor: [
          { required: false, message: "请选择挂车车牌颜色", trigger: "change" }
        ],
        trailerClassificationCode: [
          { required: false, message: "请选择挂车车辆类型", trigger: "change" }
        ],
        trailerRoadTransport: [
          {
            required: false,
            message: "请输入挂车道路运输证号",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        trailerTotalWeight: [
          { required: false, message: "请输入挂车总重量", trigger: "blur" },
          { validator: maxNumber }
        ],
        trailerLoadWeight: [
          { required: false, message: "请输入挂车可载重量", trigger: "blur" },
          { validator: maxNumber }
        ],
        isHasTrailer: [
          { required: true, message: "请选择是否挂车", trigger: "change" }
        ],
        driverLicenseDueDate: [
          {
            required: false,
            message: "请选择机动车驾驶证有效期结束日期",
            trigger: "change"
          }
        ],
        areaList: [
          { required: false, message: "请选择通信地址", trigger: "change" }
        ],

        driverLicense: [
          { required: false, message: "请输入机动车驾驶证号", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" }
        ],
        vehicleLicense: [
          {
            required: false,
            message: "请输入车辆行驶证档案编号",
            trigger: "blur"
          },
          { max: 32, message: "最大长度为32个字符" }
        ],
        roadPermitName: [
          {
            required: true,
            message: "请输入道路经营许可证业户名称",
            trigger: "blur"
          },
          { max: 255, message: "最大长度为255个字符" }
        ],
        businessUniformSocialCreditCode: [
          {
            required: false,
            message: "请输入道路经营业户社会信用代码",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        owner: [
          { required: false, message: "请输入车辆所有人", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        licenseNumber: [
          {
            required: true,
            validator(rule, value, callback) {
              validateCarNum(value)
                ? callback()
                : callback(new Error("请输入正确的号牌号码"));
            }
          }
        ],
        loadWeight: [
          {
            required: false,
            message: "请输入车辆核定载质量",
            trigger: "change"
          },
          { validator: maxNumber }
        ],
        roadTransportCertificateNumber: [
          {
            required: false,
            message: "请输入车辆道路运输证号",
            trigger: "blur"
          },
          { max: 32, message: "最大长度为32个字符" }
        ],
        vin: [
          {
            required: false,
            message: "请输入车辆识别代号",
            trigger: "blur"
          },
          { max: 255, message: "最大长度为255个字符" }
        ],
        classificationCode: [
          { required: false, message: "请选择车辆类型", trigger: "change" }
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            }
          }
        ],
        realOwnerPhone: [
          {
            required: false,
            message: "请输入车辆实际所有人联系电话",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback();
              }
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            }
          }
        ],
        password: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        isLinked: [
          {
            required: true,
            message: "请选择是否挂靠车辆",
            trigger: "change"
          }
        ],
        realOwner: [
          {
            required: false,
            message: "请输入车辆实际所有人",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        brand: [
          { required: false, message: "请输入车辆品牌", trigger: "blur" },
          { max: 200, message: "最大长度为200个字符" }
        ],
        sex: [{ required: false, message: "请选择性别", trigger: "blur" }],

        fileNo: [
          { required: true, message: "请输入档案编号", trigger: "change" }
        ],

        firstIssueDate: [
          {
            required: true,
            message: "请选择机动车驾驶证初次领证日期",
            trigger: "change"
          }
        ],
        brandModel: [
          { required: true, message: "请输入品牌型号", trigger: "change" }
        ],
        engineNo: [
          { required: true, message: "请输入发动机号码", trigger: "change" }
        ],
        approvedPassengers: [
          { required: true, message: "请输入核定载人数", trigger: "change" },
          { validator: maxNumber }
        ],
        unladenMass: [
          { required: true, message: "请输入整备质量", trigger: "change" },
          { validator: maxNumber }
        ],
        roadTransportPermitNumber: [
          {
            required: true,
            message: "请输入经营许可证号(道路运输证)",
            trigger: "change"
          }
        ],
        economicType: [
          {
            required: true,
            message: "请输入道路运输证经济类型",
            trigger: "change"
          }
        ],
        typeRoadTransportVehicle: [
          {
            required: true,
            message: "请输入请输入道路运输证车辆类型",
            trigger: "change"
          }
        ],
        shippingTon: [
          {
            required: true,
            message: "请输入道路运输证车辆吨位",
            trigger: "change"
          },
          { validator: maxNumber }
        ],
        businessScopeTransportation: [
          {
            required: true,
            message: "请输入道路运输证经营范围",
            trigger: "change"
          }
        ],
        businessScope: [
          {
            required: true,
            message: "请输入道路运输经营许可证经营范围",
            trigger: "change"
          }
        ],
        periodValidity: [
          {
            required: true,
            message: "请选择道道路运输经营许可证证件有效期",
            trigger: "change"
          }
        ],
        approvedDriving: [
          {
            required: true,
            message: "请输入道路运输从业资格证准驾车型",
            trigger: "change"
          }
        ],
        qualificationCategory: [
          {
            required: true,
            message: "请输入道路运输从业资格证从业资格类别",
            trigger: "change"
          }
        ],
        initialCertificationDate: [
          {
            required: true,
            message: "请选择道路运输从业资格证初次领证日期",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    compIsLinked() {
      return this.form.isLinked;
    },
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    disabled() {
      let istrue =
        this.requireData.vehicleClass ||
        this.requireData.driverIssuingOrganizations ||
        this.requireData.driverLicenseFromDate ||
        this.requireData.vehicleClass ||
        this.requireData.vin ||
        this.requireData.useCharacter ||
        this.requireData.vehicleIssuingOrganizations ||
        this.requireData.registerDate ||
        this.requireData.issueDate;
      return !!istrue;
    }
  },
  watch: {
    compIsLinked(val) {
      // “是否挂靠”决定了“道路经营许可证业户名称”是否为必填
      this.rules.roadPermitName[0].required = !!val;
      if (!val) {
        this.$refs.form.clearValidate(["roadPermitName"]);
      }
    },
    compTrailer(val) {
      this.$refs.form.clearValidate(["totalWeight", "loadWeight"]);
      this.rules.totalWeight[0].message = val
        ? "请输入车头整备质量"
        : "请输入车辆总质量";
      this.rules.loadWeight[0].message = val
        ? "请输入准牵引总质量"
        : "请输入核定载质量";
    },
    // 监听路由刷新
    $route: function(route) {
      this.checkQuire = !!this.$route.query.checkQuire;
      if (this.checkQuire) {
        this.form.isLinked = 1;
        this.form.isHasTrailer = 1;
        this.otherItems = true;
        this.showExtra = true;
      }
      this.findByFieldFrom();
    }
  },
  // 开启 keep-alive时使用
  activated() {
    if (JSON.stringify(this.requireData) != "{}") {
      this.findByFieldFrom(); //每次进入重新获取必填数据
    }
  },
  created() {
    this.init();
  },
  methods: {
    isVehicleType(val) {
      const TypeList = this.parentData.vehicleClassificationList.filter(
        item => item.code == val
      );
      if (TypeList[0].name.includes("牵引")) {
        this.$set(this.form, "isHasTrailer", 1);
      } else {
        this.$set(this.form, "isHasTrailer", 0);
      }
    },
    init() {
      this.reportProvinceName = this.reportProvince();
      // const partyType = this.$store.getters.party.partyType
      // this.isAdminisAdmin = partyType == 'SUPER_ADMIN' || partyType == 'PLAT_ADMIN' || partyType == 'STAFF'
      this.checkQuire = !!this.$route.query.checkQuire;
      if (this.checkQuire) {
        this.form.isLinked = 1;
        this.form.isHasTrailer = 1;
        this.otherItems = true;
        this.showExtra = true;
      }
      this.findByFieldFrom();
      let isCtmsShow = getRole();
      this.ctmsShow = !isCtmsShow;
      isTaxOpen().then(res => {
        this.hasTaxOpen = res.data;
      });
    },
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(
        this.form,
        key,
        value.replace(/\.[0-9]+/g, "").replace(/\D/g, "")
      );
    },
    // 查询必填项
    async findByFieldFrom() {
      let response = await findByFieldFrom({ fieldFrom: "driver" });
      this.requireData = response.data;
      for (let key in this.requireData) {
        if (this.rules[key])
          this.rules[key][0].required = !!this.requireData[key];
      }
      this.rules.width[0].required = this.requireData.dimension;
      this.rules.height[0].required = this.requireData.dimension;
      this.rules.length[0].required = this.requireData.dimension;
    },
    // 保存必填设置
    async funcSaveSet() {
      const rLoading = this.openLoading();
      let response = await updateFieldRequired({
        message: this.requireData,
        fieldFrom: "driver"
      });
      rLoading.close();
      this.$message.success(response.msg);
      this.$router.push({
        path: "/basicInfo/driver/driverManage"
      });
    },
    // 设置必填
    setQuired(key) {
      if (key == "dimension") {
        this.rules.width[0].required = this.requireData.dimension;
        this.rules.height[0].required = this.requireData.dimension;
        this.rules.length[0].required = this.requireData.dimension;
        return;
      }
      this.rules[key][0].required = !!this.requireData[key];
    },
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const isDriverLicenseDateError =
              this.form.driverLicenseFromDate >= this.form.driverLicenseDueDate,
            isDateError = this.form.registerDate > this.form.issueDate;
          if (isDriverLicenseDateError) {
            this.$message({
              message: "请选择正确的驾驶证有效日期范围",
              type: "error"
            });
            return false;
          }

          if (isDateError) {
            this.$message({
              message: "请选择正确的注册日期和发证日期",
              type: "error"
            });
            return false;
          }
          if (
            this.ficationImgRes.length > 0 ||
            this.driverLicenseRes.length > 0
          ) {
            if (
              this.ficationImgRes.data.name == this.driverLicenseRes.data.name
            ) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          } else {
            this.form.ocrResult = 1;
          }

          const rLoading = this.openLoading();
          for (let key in this.form) {
            if (key !== "vehicleDTO") {
              this.form.vehicleDTO[key] = this.form[key];
            }
          }
          this.form.vehicleVO["roadPermitNumber"] = this.form[
            "roadPermitNumber"
          ];
          this.form.vehicleVO["roadPermitNumberImg"] = this.form[
            "roadPermitNumberImg"
          ];
          if (this.form.isHasTrailer !== 1) {
            this.form.trailerRoadTransportCertificateImg = "";
            this.form.trailerVehicleImg = "";
            this.form.trailerVehicleLicenseImg = "";
            this.form.trailerNum = "";
            this.form.trailerRoadTransport = "";
          }
          addDriverTeam(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$refs.form.resetFields();
            this.$router.push({
              path: "/basicInfo/driver/driverManage",
              query: { needRefreshDriver: true }
            });
          });
        }
        // else {
        //   this.$message.error("请正确填写选项");
        // }
      });
    },
    // 身份证正面识别
    async ficationImgSuccess(url) {
      this.ficationImgRes = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFront"
      });
      let data = this.ficationImgRes.data;
      data.name ? this.$set(this.form, "name", data.name) : null;
      if (this.ficationImgRes.data) {
        if (data.name != this.driverLicenseRes.name) {
          this.$message({
            message: "上传的身份证与驾驶证姓名不匹配",
            type: "warning"
          });
        }
      }
      data.identity
        ? this.$set(this.form, "identificationNumber", data.identity)
        : null;
      data.address ? this.$set(this.form, "homeAddress", data.address) : null;
      if (data.provinceCode) {
        this.$set(this.form, "provinceCode", data.provinceCode);
        this.$set(this.form, "cityCode", data.cityCode);
        this.$set(this.form, "countyCode", data.countyCode);
        this.$set(this.form, "areaList", [
          data.provinceCode,
          data.cityCode,
          data.countyCode
        ]);
      }
    },
    // 身份证反面识别
    async ficationImgBackSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFrontBack"
      });
      let data = res.data;
      if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
        this.$set(this.form, "hasDueDate", true);
        this.$set(this.form, "idCardDueDate", "9999-12-31");
      } else if (data.expiryDate) {
        let time = data.expiryDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let expiryDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "idCardDueDate", expiryDate);
          this.$set(this.form, "hasDueDate", false);
        }
      }
    },
    // 驾驶证正面识别
    async driverLicenseSuccess(url) {
      this.driverLicenseRes = await getOcr({
        image: url,
        ocrType: "ocrDrivingLicense"
      });

      let data = this.driverLicenseRes.data;
      if (this.driverLicenseRes.msg == "请确认上传驾驶证件是否正确") {
        this.$message({
          message: this.driverLicenseRes.msg,
          type: "warning"
        });
      }

      this.form.driverLicenseName = data.name;
      if (this.ficationImgRes.data) {
        if (data.name != this.ficationImgRes.data.name) {
          setTimeout(() => {
            this.$message({
              message: "上传的驾驶证与身份证姓名不匹配",
              type: "warning"
            });
          }, 1000);
        }
      }
      data.certificateNumber
        ? this.$set(this.form, "driverLicense", data.certificateNumber)
        : null;
      data.orgOfIssue
        ? this.$set(this.form, "driverIssuingOrganizations", data.orgOfIssue)
        : null;
      if (data.validStartDate) {
        let time = data.validStartDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "driverLicenseFromDate", validStartDate);
        }
      }
      // 机动车驾驶证初次领证日期
      if (data.firstDate) {
        let time = data.firstDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "firstIssueDate", validStartDate);
        }
      }
      if (data.validDate == "长期" || data.validDate == "9999-12-31") {
        this.$set(this.form, "hasDriverDueDate", true);
        this.$set(this.form, "driverLicenseDueDate", "9999-12-31");
      } else if (data.validDate) {
        let time = data.validDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "driverLicenseDueDate", validDate);
          this.$set(this.form, "hasDriverDueDate", false);
        }
      }
      this.parentData.vehicleTypeAllowList.map((item, index) => {
        if (item.name == data.canDrivingType) {
          this.$set(this.form, "vehicleClass", data.vehicleClass);
        }
      });
    },
    // 驾驶证副页识别
    async driverLicenseBackSuccess(url) {
      this.ocrDrivingLicenseFY = await getOcr({
        image: url,
        ocrType: "ocrDrivingLicenseFY"
      });
      let data2 = this.ocrDrivingLicenseFY.data;
      if (this.ocrDrivingLicenseFY.msg == "请确认上传驾驶证件是否正确") {
        this.$message({
          message: this.ocrDrivingLicenseFY.msg,
          type: "warning"
        });
      }
      data2.fileNo ? this.$set(this.form, "fileNo", data2.fileNo) : null;
    },
    // 行驶证识别
    async vehicleLicenseSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicense" });
      let data = res.data;
      data.plateNumber
        ? this.$set(this.form, "licenseNumber", data.plateNumber)
        : null;
      data.fileNumber
        ? this.$set(this.form, "vehicleLicense", data.fileNumber)
        : null;
      data.useNature
        ? this.$set(this.form, "useCharacter", data.useNature)
        : null;
      data.identificationNumber
        ? this.$set(this.form, "vin", data.identificationNumber)
        : null;
      // 品牌型号
      data.brandModel
        ? this.$set(this.form, "brandModel", data.brandModel)
        : null;
      //车辆行驶证发证机关
      data.orgOfIssue
        ? this.$set(this.form, "vehicleIssuingOrganizations", data.orgOfIssue)
        : null;
      // 发动机号码
      data.engineNumber
        ? this.$set(this.form, "engineNo", data.engineNumber)
        : null;
      data.owner ? this.$set(this.form, "owner", data.owner) : null;
      if (data.registrationDate) {
        let time = data.registrationDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let registrationDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "registerDate", registrationDate);
        }
      }
      if (data.dateOfIssue) {
        let time = data.dateOfIssue.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let dateOfIssue =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "issueDate", dateOfIssue);
        }
      }
    },
    // 行驶证副页识别
    async vehicleLicenseBackSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicenseBack" });
      let data = res.data;
      data.fileNumber
        ? this.$set(this.form, "vehicleLicense", data.fileNumber)
        : null;
      data.passengersCapacity
        ? this.$set(this.form, "approvedPassengers", data.passengersCapacity)
        : null;
      let loadWeight = "",
        totalWeight = "";
      if (data.totalMass || data.loadCapacity) {
        // 若识别出“总质量”和“核定载质量”，则设置“是否挂车”为“否”
        loadWeight = data.totalMass || loadWeight;
        totalWeight = data.loadCapacity || totalWeight;
        this.$set(this.form, "isHasTrailer", 0);
      }
      if (data.tractionMass || data.curbWeight) {
        // 若识别出“整备质量”和“准牵引总质量”，则设置“是否挂车”为“是”
        loadWeight = data.tractionMass || loadWeight;
        totalWeight = data.curbWeight || totalWeight;
        this.$set(this.form, "isHasTrailer", 1);
      }
      // 车辆行驶证到期日
      if (data.inspectionRecord) {
        let time = data.inspectionRecord.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let inspectionRecord =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "vehicleLicenseDueDate", inspectionRecord);
        }
      }
      // 整备质量
      data.curbWeight
        ? this.$set(
            this.form,
            "unladenMass",
            data.curbWeight.replace(/\D/g, "")
          )
        : null;
      // 核定载人数
      data.passengersCapacity
        ? this.$set(
            this.form,
            "approvedPassengers",
            data.passengersCapacity.replace(/\D/g, "")
          )
        : null;
      loadWeight
        ? this.$set(this.form, "loadWeight", loadWeight.replace(/\D/g, ""))
        : null;
      totalWeight
        ? this.$set(this.form, "totalWeight", totalWeight.replace(/\D/g, ""))
        : null;
      if (data.gabarite) {
        let gabarite = data.gabarite.replace(/mm|MM/, "");
        gabarite = gabarite.split("X");
        if (gabarite.length == 3) {
          this.$set(this.form, "length", gabarite[0]);
          this.$set(this.form, "width", gabarite[1]);
          this.$set(this.form, "height", gabarite[2]);
        }
      }
      if (data.fuelType) {
        let vehicleEnergyType = "";
        this.parentData.vehicleEnergyTypeList.forEach(function(item) {
          if (item.name == data.fuelType) {
            vehicleEnergyType = item.code;
          }
        });
        this.$set(this.form, "vehicleEnergyType", vehicleEnergyType);
      }
    },

    // 挂车行驶证正页
    async trailerVehicleLicenseImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicense" });
      let data = res.data;
      data.plateNumber
        ? this.$set(this.form, "trailerNum", data.plateNumber)
        : null;
      const item = this.parentData.vehicleClassificationList.find(
        ele => ele.name == data.vehicleType
      );
      this.$set(this.form, "trailerClassificationCode", item ? item.code : "");
    },
    // 挂车行驶证副页
    async trailerVehicleLicenseDeputyPageImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicenseBack" });
      let data = res.data;
      this.$set(
        this.form,
        "trailerLoadWeight",
        data.loadCapacity ? data.loadCapacity.replace(/\D/g, "") : ""
      );
      this.$set(
        this.form,
        "trailerTotalWeight",
        data.totalMass ? data.totalMass.replace(/\D/g, "") : ""
      );
    },
    // 挂车道路运输证识别
    async trailerTransportCertificateImgSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrRoadTransportCertificateFY"
      });
      let data = res.data;
      data.hao
        ? this.$set(
            this.form,
            "trailerRoadTransport",
            data.hao.replace(/\u53f7/g, "")
          )
        : null;
    },
    // 从业资格证识别
    async workLicenseSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrQualificationCertificate"
      });
      let data = res.data;
      data.zhenghao ? this.$set(this.form, "workLicense", data.zhenghao) : null;
      // 准驾车型
      data.zhunjiachexing
        ? this.$set(this.form, "approvedDriving", data.zhunjiachexing)
        : null;
      // 从业资格类别
      data.congyezigeleibie
        ? this.$set(this.form, "qualificationCategory", data.congyezigeleibie)
        : null;
      // 道路运输从业资格证初次领证日期
      if (data.chucilingzhengriqi) {
        let time = data.chucilingzhengriqi.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "initialCertificationDate", validStartDate);
        }
      }
      if (data.youxiaoqixian) {
        let time = data.youxiaoqixian.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let value =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "workLicenseDueDate", value);
        }
      }
    },
    // 道路运输证识别
    async roadTransportCertificateSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrRoadTransportCertificateFY"
      });
      // let res = await getOcr({
      //   image: url,
      //   ocrType: "ocrRoadTransportCertificate"
      // });
      let data = res.data;
      // let fuyedata = fuye.data;
      // 道路运输证许可证号
      data.jingyingxukezhenghao
        ? this.$set(
            this.form,
            "roadTransportPermitNumber",
            data.jingyingxukezhenghao
          )
        : null;
      // 道路运输证许可证号
      data.dunwei ? this.$set(this.form, "shippingTon", data.dunwei) : null;
      // 经济类型
      data.jingjileixing
        ? this.$set(this.form, "economicType", data.jingjileixing)
        : null;
      //  // 经营范围
      data.businessScopeTransportation
        ? this.$set(
            this.form,
            "businessScopeTransportation",
            data.businessScopeTransportation
          )
        : null;
      // 道路运输证车辆类型
      data.cheliangleixing
        ? this.$set(this.form, "typeRoadTransportVehicle", data.cheliangleixing)
        : null;
      data.hao
        ? this.$set(
            this.form,
            "roadTransportCertificateNumber",
            data.hao.replace(/\u53f7/g, "")
          )
        : null;
      if (data.roadTransportCertificateDate) {
        let time = data.roadTransportCertificateDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let value =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "roadTransportCertificateDate", value);
        }
      }
      // if (data.cheliangleixing || data.cheliangleixing2) {
      //   let item = this.parentData.vehicleClassificationList.find(
      //     item =>
      //       item.name == data.cheliangleixing ||
      //       item.name == data.cheliangleixing2
      //   );
      //   item ? this.$set(this.form, "classificationCode", item.code) : null;
      // }
      // data.chelianghaopai?this.$set( this.form ,'licenseNumber', data.chelianghaopai.replace(/\((.+)\)/g,'')):null
      let vehicleLicenseColor = data.chelianghaopai.match(/\(([^)]*)\)/)
        ? data.chelianghaopai.match(/\(([^)]*)\)/)[1]
        : null;
      if (vehicleLicenseColor) {
        this.parentData.vehicleLicenseColorList.map((item, index) => {
          if (item.name == vehicleLicenseColor) {
            this.$set(this.form, "vehicleLicenseColor", item.code);
          }
        });
      }
    },
    // 道路经营许可证照片
    async roadPermitNumberSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrRoadPermitNumber" });
      let data = res.data;
      data.hao ? this.$set(this.form, "roadPermitNumber", data.hao) : null;
      // 业户名称
      data.yehumingcheng
        ? this.$set(this.form, "roadPermitName", data.yehumingcheng)
        : null;
      data.jingyingfanwei
        ? this.$set(this.form, "businessScope", data.jingyingfanwei)
        : null;
      // 道路经营许可证照片证件有效期
      if (data.youxiaoqi_start && data.youxiaoqi_end) {
        let youxiaoqi = data.youxiaoqi_start + "-" + data.youxiaoqi_end;
        this.$set(this.form, "periodValidity", youxiaoqi);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 10px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
</style>
